import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { VITAMINS } from "../../../../constants";


export default function VitaminsAddOnCard() {
  

return (

    <CardImageMarkers 
    
        image={VITAMINS}
        title="VITAMINS & MICRONUTRIENTS"
        subtitle="Advanced nutrient profiling: covering key vitamins and trace minerals beyond the essentials for deeper insights into your nutritional health"
        markersTitle="€ 419,- incl. VAT"
        markers="Vitamin B1, Vitamin B2, Vitamin B6, Biotin (Vitamin B7), Folate (Vitamin B9), Vitamin K1, Vitamin K2, Beta-Carotene (Provitamin A), Retinol (Vitamin A), Vitamin E, Ascorbic Acid (Vitamin C), Zinc, Copper, Selenium"

    />


)
}